'use client';

import { ChipNavigator } from '@baseline/ui';
import Link from 'next/link';
import { useRouter } from 'nextjs-toploader/app';
import commonStyles from '@/app/(website)/commonStyles.module.scss';
import styles from './resourceHeader.module.scss';

type ResourceHeaderProps = {
  selectedLinkId?: string;
};

export default function ResourceHeader({
  selectedLinkId
}: ResourceHeaderProps) {
  const router = useRouter();

  return (
    <section
      className={`${styles.resourceHeader} ${commonStyles.sectionContent}`}
    >
      <ChipNavigator
        selectedLinkId={selectedLinkId}
        onMobileSelect={(href) => {
          router.push(href);
        }}
        renderLinkComponent={({ className, href, label }) => (
          <Link href={href} className={className}>
            {label}
          </Link>
        )}
      />
    </section>
  );
}
